<div>
    <div id="clock-wrapper">
        <mat-icon  aria-hidden="true">{{ iconClock }}</mat-icon>
    </div>
    <div class="text-center txt-color">
        <h1>Coming Soon</h1>
    </div>
    <div class="text-center txt-color">
        Get ready, something cool is coming!
    </div>
</div>